import * as Sentry from "@sentry/react";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

function usePageTracking() {
  const location = useLocation();

  useEffect(() => {
    Sentry.captureMessage(`Navigated to ${location.pathname}`, "log");
  }, [location]);
}

export { usePageTracking };
